<template>
    <div>

        <rkm-form
            ref="FormSupervisor"
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">

                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :requestQueryStringParams="autocompleteRequestParams.usuario"
                        :searchFields="fields.autocomplete.usuario"
                        :validations="validations.usuario"
                        text-field="cidadaoNome"
                        label="Profissional"
                        placeholder="Digite o nome ou número do conselho profissional"
                        v-model="model.usuario"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">

                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.FormSupervisor.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items="data.model.outros.supervisores"
            :fields="fields.table"
            ref="Table"
        >

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    @click="handleDestroy(index, item)"
                    title="Excluir"
                    color="danger"
                    small
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

export default {
    computed: {
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                },
                table: [
                    { key: 'usuarioNome', label: 'Profissional', sortable: true },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                },
            }
        },
        validations() {

            return {
                usuario: { required: true, },
            }
        },
    },
    data: () => ({
        model: {
            usuario: null,
        },
    }),
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    methods: {
        async validate() {

            return true
        },
        async verificaDuplicidade() {

            const existeSupervisor = this.data.model.outros.supervisores
                .find(supervisor => supervisor.usuarioId === this.model.usuario.id)

            if (existeSupervisor) {

                this.showValidationNotification('Supervisor já cadastrado')

                return false
            }

            return true
        },
        add() {

            this.verificaDuplicidade().then(isValid => {

                if (!isValid) return

                const usuario = this.clone(this.model.usuario)

                const supervisor = {
                    usuarioId: usuario.id,
                    usuarioNome: usuario.cidadaoNome,
                }

                this.data.model.outros.supervisores.push(supervisor)

                this.limpaFormulario()
            })
        },
        limpaFormulario() {

            this.model.usuario = null

            this.$nextTick()
                .then(() => this.$refs.FormSupervisor.resetValidator())
        },
        handleDestroy(index) {

            const destroy = async () => this.data.model.outros.supervisores.splice(index, 1)

            this.showDeleteConfirmation(
                'Deseja realmente excluir o supervisor?',
                destroy,
                this.handleError
            )
        },
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    }
}

</script>